<template>
    <div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Sebab Tidak Ditemukan <span
                    class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Sebab Tidak Ditemukan" rules="required">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="hilang-tidak-ditemukan">
                            Hilang Tidak Ditemukan
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="hilang-karena-kecurian">
                            Hilang Karena Kecurian
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="usang-hancur">
                            Usang/Hancur
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.sebab_tidak_ditemukan" value="keadaan-kahar">
                            Keadaan Kahar (Force Majeure)
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.sebab_tidak_ditemukan"
                            value="dipindahtangankan-dimusnahkan-belum-dihapus">
                            Dipindahtangankan/Dimusnahkan, Belum dihapus
                        </b-form-radio>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

            </div>
        </div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Kronologis <span class="text-danger">*</span></span>
            <div class="col-12 mt-50">
                <validation-provider #default="{ errors }" name="Kronologis" rules="required|min:140">
                    <b-form-textarea id="textarea-state" v-model="formDatas.kronologis"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Isi kronologis, minimal 140 Karakter" rows="3" />
                    <small class="textarea-counter-value float-right"
                        :class="formDatas.kronologis.length < minChar ? 'bg-danger' : ''">
                        <span class="char-count">minimal karakter: {{ formDatas.kronologis.length }}</span> / {{
                            minChar }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
        </div>
        <template v-if="formDatas.sebab_tidak_ditemukan == 'dipindahtangankan-dimusnahkan-belum-dihapus'">
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Dokumen SK <span class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="Dokumen SK" rules="required">
                        <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                            <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="tidak">
                                Tidak Ada SK
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="iya">
                                Ada Dokumen SK
                            </b-form-radio>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
            <div class="row mb-2" v-if="formDatas.is_dokumen_pendukung_sk == 'iya'">
                <span class="col-12 font-weight-bold font-small-5">Upload Dokumen SK <span class="text-danger">*</span>
                    <small class="text-danger"> (Maksimal 2 mb dan format PDF)</small></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="File Dokumen SK" rules="required">
                        <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                            <b-form-file v-model="uploadedFileDokumenSK" accept="application/pdf"
                                @change="handleFileChange" />
                        </div>
                        <div class="mt-25"
                            v-if="formDatas.file_dokumen_sk && (typeof formDatas.file_dokumen_sk !== 'object')">
                            <a target="_blank" :href="formDatas.file_dokumen_sk">
                                <div class="text-wrap"><feather-icon icon="DownloadCloudIcon" class="mr-50" />
                                    <span>Download File Terupload</span>
                                </div>
                            </a>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Dokumen Pendukung <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="Dokumen Pendukung" rules="required">
                        <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                            <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="tidak">
                                Tidak Ada
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_dokumen_pendukung_sk" value="iya">
                                Ada Dokumen Pendukung
                            </b-form-radio>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
            <div class="row mb-2" v-if="formDatas.is_dokumen_pendukung_sk == 'iya'">
                <span class="col-12 font-weight-bold font-small-5">Dokumen Pendukung Berupa <span
                        class="text-danger">*</span></span>
                <div class="col-12 mt-50">
                    <validation-provider #default="{ errors }" name="Dokumen Pendukung Berupa" rules="required">
                        <b-form-input v-model="formDatas.dokumen_pendukung_berupa" placeholder="Isi Dokumen Pendukung" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect } from '@vue/composition-api'
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import daftarBmd from "@/composables/b/daftarBmd";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        bmd: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
        updateItem: Function,
    },
    setup(props, context) {
        const g = context.root;
        const formDatas = ref(props.fD);
        formDatas.value.kronologis = '';

        const minChar = 140;
        const uploadedFileDokumenSK = ref(null);
        const handleFileChange = (event) => {
            formDatas.value.file_dokumen_sk = null;
            const fileInput = event.target;
            if (fileInput.files.length > 0) {
                const file = fileInput.files[0];
                const fileSize = fileInput.files[0].size / 1024 / 1024; // in MB
                const maxFileSize = 2; // 2 MB
                const allowedFileType = 'application/pdf';

                if (file.type !== allowedFileType) {
                    showNotifikasi(g, 'warning', 'Warning', `File yang diupload harus berformat PDF`);
                    uploadedFileDokumenSK.value = null;
                    fileInput.value = '';
                } else if (fileSize > maxFileSize) {
                    showNotifikasi(g, 'warning', 'Warning', `File yang diupload maksimal ${maxFileSize} Mb`);
                    uploadedFileDokumenSK.value = null;
                    fileInput.value = '';
                } else {
                    formDatas.value.file_dokumen_sk = file;
                }
            }
        }
        return {
            formDatas,
            uploadedFileDokumenSK,
            handleFileChange,
            minChar
        }
    },
    computed: {
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
    },
    directives: {
        Ripple,
    },
    methods: {
    },
    data() {
        return {
            required,
        }
    },
}
</script>